import { sanitizeMerchantRedirectUrl } from './merchantRedirectUrl';

export const LocationRoutes = {
  PAYMENT_HANDLER: 'handle-payment',
};

/**
 * Path prefix of the iOS <= 16 Apple Pay fallback tab (`/apple-pay/:token`).
 * See `utils/applePayTabFallback.ts`.
 */
export const APPLE_PAY_TAB_ROUTE = 'apple-pay';

/** Path prefix of the Chargebee subscription checkout (`/subscriptions/:token`). */
export const SUBSCRIPTIONS_ROUTE = 'subscriptions';

export const getCurrentDomain = () => {
  return window.location.origin;
};
export const shouldRenderPaymentHandlerPage = () => {
  return window.location.pathname.startsWith(`/${LocationRoutes.PAYMENT_HANDLER}/`);
};

/** TRUE when this window is the Apple Pay fallback tab (top-level, real button). */
export const isApplePayTabMode = () => {
  return window.location.pathname.startsWith(`/${APPLE_PAY_TAB_ROUTE}/`);
};

/** TRUE on the Chargebee subscription route, which has no `/checkout/v3` session. */
export const isSubscriptionRoute = () => {
  return window.location.pathname.startsWith(`/${SUBSCRIPTIONS_ROUTE}/`);
};
export const redirectUser = (redirectLink: string): boolean => {
  const safeRedirectLink = sanitizeMerchantRedirectUrl(redirectLink);
  if (!safeRedirectLink) return false;
  window.location.href = safeRedirectLink;
  return true;
};

export const getSessionIdFromUrlParams = () => {
  const token = location.pathname.slice(1);
  // Prefixed routes keep the session token as the segment AFTER the route
  // prefix; everywhere else the whole path IS the token. Without this the
  // subscription route yields `subscriptions/<token>`, which leaks into the
  // Authorization header and every analytics `sessionId`.
  for (const prefix of [APPLE_PAY_TAB_ROUTE, SUBSCRIPTIONS_ROUTE]) {
    if (token.startsWith(`${prefix}/`)) {
      return token.slice(prefix.length + 1);
    }
  }
  return token;
};
